<template>
  <div
    class="pa-3"
    style="height: 340px">
    <v-text-field
      filled
      style="height: 66px"
      label="Name"
      v-model="data.name"
      v-on:keyup.enter="$emit('create')"></v-text-field>
    <v-textarea
      filled
      label="Text"
      v-model="data.text"></v-textarea>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';

const props = defineProps({
  userEditObj: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:data', 'create']);

const data = reactive({
  name: '',
  text: '',
});

// Watch for changes in the data and emit them
watch(
  data,
  () => {
    emit('update:data', JSON.parse(JSON.stringify(data)));
  },
  { deep: true, immediate: true }
);
</script>
